// ToggleSwitch.jsx
import * as style from './style.module.css';

const ToggleSwitch = ({ register, checked = false, onChange = () => {}, size = 'm', disabled = false, ariaLabel = undefined }) => {
    // Define the good input depending on the usage (with react-hook-form or not)
    const inputProps = register ? { ...register, disabled } : { checked, onChange, disabled };
    return (
        <label className={`${style.switchContainer} ${style[`switchContainer_${size}`]} ${disabled ? style.disabled : ''}`}>
            <input type="checkbox" aria-label={ariaLabel} {...inputProps} />
            <span />
        </label>
    );
};

export default ToggleSwitch;
